import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../styles.scss";
import { setLoading } from "../../../redux/actions/app";
import TestsID from "../../../utils/TestsID";
import AddressEditor, {
  handleAddressSubmit
} from "../../AddressEditor/AddressEditor";
import {
  setShippingAddress,
  useAccountToDisplaySelector
} from "../../../redux/actions/user";
import SaasFlyersOrderActionWrapper from "./SaasFlyersOrderActionWrapper";
import { tt } from "../../../utils/i18n/i18n";
import { createPOSADeliveryAndBills } from "../../../app/13_SaaS/api";
import { SAAS_FLYERS_ORDER } from "../../../utils/routes/routes";
import { useHistory } from "react-router-dom";
import { setFlyersOrderStep } from "../../../redux/saas/reducer";
import { type RootStateI } from "../../../redux";
import { updatePOSAOrderThunk } from "../../../redux/saas/thunks";
import {
  FLYERS_ORDER_STEP_PAYMENT,
  FLYERS_ORDER_STEP_QUANTITY
} from "../../../utils/constants";
import { buildPathWithTrackingId } from "../../../utils/routing/routingUtils";

// TODO EGH: remove this
const SaasFlyersOrderDelivery = () => {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const history = useHistory();
  const saasFlyersOrder = useSelector(
    (state: RootStateI) => state.saas.currentPOSAOrder
  );

  const [nextDisabled, setNextDisabled] = useState(false);

  const setIsLoading = (state: boolean) => {
    dispatch(setLoading(state));
  };

  async function handlePrev() {
    dispatch(setFlyersOrderStep(FLYERS_ORDER_STEP_QUANTITY));
  }

  async function handleNext(e: React.SyntheticEvent, extraProps?: any) {
    dispatch(setShippingAddress(extraProps.trackingID, extraProps.address));
    await handleAddressSubmit(extraProps.address, extraProps.trackingID);

    if (
      !accountToDisplay?.trackingID ||
      !accountToDisplay?.businessUser?.shippingAddress ||
      !saasFlyersOrder?.items ||
      !accountToDisplay?.token
    ) {
      return;
    }

    try {
      const posaDeliveryWithBillResponse = await createPOSADeliveryAndBills(
        accountToDisplay?.trackingID,
        accountToDisplay?.token,
        saasFlyersOrder.items
      );

      dispatch(
        updatePOSAOrderThunk({
          ...saasFlyersOrder,
          billAndDelivery: posaDeliveryWithBillResponse
        })
      );
      dispatch(setFlyersOrderStep(FLYERS_ORDER_STEP_PAYMENT));
      history.push(
        buildPathWithTrackingId(
          `${SAAS_FLYERS_ORDER}/${posaDeliveryWithBillResponse[0]?.billId}`,
          accountToDisplay?.trackingID
        )
      );
    } catch (err) {
      console.error(err);
      alert(tt("api_error"));
    }
  }

  const onAddressValidityChanged = (isValid: boolean) => {
    setNextDisabled(!isValid);
  };

  if (accountToDisplay == null) {
    return null;
  }

  return (
    <div
      id={TestsID.SAAS_FLYERS_ORDER_PAGE_DELIVERY_CONTAINER}
      className="saas-flyers-order__delivery-container"
    >
      {!!accountToDisplay?.trackingID && (
        <AddressEditor
          trackingID={accountToDisplay?.trackingID}
          address={accountToDisplay?.businessUser?.shippingAddress}
          setIsLoading={setIsLoading}
          onValidChanged={onAddressValidityChanged}
          ActionsComponent={(props) => (
            <SaasFlyersOrderActionWrapper
              actionsLabel={[
                tt("saas_flyers_order_delivery_action_prev"),
                tt("saas_flyers_order_delivery_action_next") + " >"
              ]}
              nextDisabled={false}
              handleNext={handleNext}
              handlePrev={handlePrev}
              {...props}
            />
          )}
        />
      )}
    </div>
  );
};

export default SaasFlyersOrderDelivery;
